import React, { useState } from 'react';
import JobChannelSelector from './JobChannelSelector';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { AudioChannelSetting } from '../../models/dto/audioChannelSetting';
import api from '../../helpers/api';
import {
	JobCreate,
	JobSummary
} from '../../models/dto/job';
import { CallDirection } from '../../models/dto/callDirection';
import { formatDate } from '../../helpers/dates';
import './CreateBasicJobPage.scss';
import CreateJobHeader from './CreateJobHeader';

export default function CreateBasicJobPage(props: { engagementId: number; }) {
	const [isCreating, setIsCreating] = useState<boolean>(false);
	const history = useHistory();
	
	return (
		<React.Fragment>
			<CreateJobHeader engagementId={props.engagementId} jobName={''} progressStatus="none" />

			<div className="create-basic-job__container">
				<JobChannelSelector engagementId={props.engagementId} jobId={null} onChannelsMapped={createJob} isChannelRequestPending={isCreating} />
			</div>
		</React.Fragment>
	);
	
	function createJob(audioChannel: AudioChannelSetting): void {
		if (isCreating) return;
		
		setIsCreating(true);

		const request: JobCreate = { 
			engagementId: props.engagementId, 
			name: getDefaultJobName(), 
			audioChannel, 
			direction: CallDirection.Unknown, 
			customFieldValues: null, 
			calls: [], 
			createdWithoutCallManifest: true 
		};
		
		api.post<JobSummary>(`/api/jobs`, request).then(response => {
			history.push(`/engagements/${props.engagementId}/jobs/${response.data.id}`)
		}, () => {
			setIsCreating(false);
		});
	}
	
	function getDefaultJobName(): string {
		return `My calls ${formatDate(new Date())}`;
	}
}
